/**
 * @file コンポーネント：RavnurPlayer DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledPlayerContainer, StyledRavnurPlayer } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledPlayerContainer
            id={props.mediaId}
            className={[
                props.hideControl && "hideControl",
                props.hidePlaceholder && "hidePlaceholder",
                !props.hasAudio && "hideVolume",
            ]}
        >
            <StyledRavnurPlayer id="player" />
        </StyledPlayerContainer>
    );
};
